import { normalizeLandingSections } from '../publicPage/registry'
import { getDefaultPersonalTemplateCode, resolvePersonalTemplateCode } from './registry'

/**
 * DB/요청에 객체 래퍼 `{ version: 2, style?, sections }`가 오는 경우(향후) 언랩.
 * 현재 API는 배열만 내려주지만, 로컬 프리셋·수동 JSON 대비.
 */
export function unwrapPersonalLandingPayload(raw) {
  if (raw == null) return { version: 1, style: {}, sections: [] }
  if (Array.isArray(raw)) return { version: 1, style: {}, sections: raw }
  if (typeof raw === 'object') {
    if (Number(raw.version) === 2 && Array.isArray(raw.sections)) {
      const style = raw.style && typeof raw.style === 'object' ? raw.style : {}
      return { version: 2, style, sections: raw.sections }
    }
    if (Array.isArray(raw.sections) && !Array.isArray(raw.landingSections)) {
      const style = raw.style && typeof raw.style === 'object' ? raw.style : {}
      return { version: Number(raw.version) === 2 ? 2 : 1, style, sections: raw.sections }
    }
    if (Array.isArray(raw.landingSections)) {
      return { version: 1, style: {}, sections: raw.landingSections }
    }
  }
  return { version: 1, style: {}, sections: [] }
}

function enrichSection(section) {
  if (!section || typeof section !== 'object') return section
  const type = section.type
  const code = resolvePersonalTemplateCode(type, section.templateCode)
  const assets = section.assets && typeof section.assets === 'object' ? section.assets : {}
  return { ...section, templateCode: code || getDefaultPersonalTemplateCode(type), assets }
}

/**
 * @param {Record<string, unknown>|null|undefined} apiStyle — API `landingPageStyle` (DB V2 style)
 * @returns {{ version: number, style: Record<string, unknown>, sections: Array }}
 */
export function normalizePersonalLandingState(rawLandingInput, data = {}, apiStyle = null) {
  const { version, style, sections: rawSections } = unwrapPersonalLandingPayload(rawLandingInput)
  const mergedStyle = {
    ...(style && typeof style === 'object' ? style : {}),
    ...(apiStyle && typeof apiStyle === 'object' ? apiStyle : {}),
  }
  const base = normalizeLandingSections(rawSections, data)
  const sections = base.map(enrichSection)
  const v = version >= 2 ? version : Object.keys(mergedStyle).length ? 2 : version
  return { version: v, style: mergedStyle, sections }
}

/** 공개 페이지·에디터에서 섹션 배열만 필요할 때 */
export function normalizePersonalLandingSections(rawLandingInput, data = {}, apiStyle = null) {
  return normalizePersonalLandingState(rawLandingInput, data, apiStyle).sections
}
